import { Stack } from 'components';

import style from './branch.module.scss';

const Branch = ({ children, label }: { children?: React.ReactNode; label: React.ReactNode }) => {
  return (
    <Stack pl="26px" position="relative" className={style.verticalBranch}>
      <Stack position="relative" className={style.branch} mb="2px">
        {label}
      </Stack>
      {children}
    </Stack>
  );
};

export default Branch;
